// extracted by mini-css-extract-plugin
export default {"button":"Overview-module__button__lHk5m"};